



















































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DniField from "@/components/DniField.vue";
import ReusableButton from "@/components/ReusableButton.vue";
import {
  Configuration,
  TitleTemplatePublic,
  SelectedCountry,
  RedCapital,
} from "@/configuration";
import API from "@/api";
import { DniTrim, parseNombreCompleto } from "@/utils";
import { EventBus } from "@/main";
//@ts-ignore
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
import DniBusiness from "@/components/dniBusiness/DniFieldBusinessRegister.vue";

@Component({
  metaInfo: {
    title: "Registrarse",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    },
  },
  data() {
    return {
      tokenn:'',
      showPassword:false,
      errors:[],
      tipo_solicitud:'',
      businessData:[],
      RedCapital,
      SelectedCountry,
      terms: false,
      contratoSolicitante: false,
      contratoInversor: false,
      showError: false,
      type: [
        {
          id: 2,
          value: "Invertir",
        },
        {
          id: 3,
          value: "Solicitar financiamiento",
        },
      ],
      user: {
        name: "",
        lastname: "",
        email: "",
        password: "",
        c_password: "",
        dni: "",
        phone: "",
        type: 2,
        via_id: 1,
        utm_source:null
      },
      rules: {
        name: [(v: any) => !!v || "Nombre es requerido"],
        lastname: [(v: any) => !!v || "Apellido es requerido"],
        rut: [
          // @ts-ignore
          (v: any) => !!v || `${RedCapital[SelectedCountry].DniName} es requerido`,
          // @ts-ignore
          (v: any) => /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/.test(v) || `${RedCapital[SelectedCountry].DniName} invalido Ej: 12.345.678-9`,
        ],
        ruc: [
          // @ts-ignore
          (v: any) => !!v || `${RedCapital[SelectedCountry].DniName} es requerido`,
          // @ts-ignore
          (v: any) => v.toString().length != 11 || `${RedCapital[SelectedCountry].DniName} no válido`,
        ],
        password: [],
        email: [
          (v: any) => !!v || "E-mail es requerido",
          (v: any) => /^.+@.+\..+/gi.test(v) || "El e-mail tiene que ser valido",
        ],
        phone: [
          (v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo números",
          (v: any) => !!v || "Teléfono es requerido",
          (v: any) => v.length >= 9 || "Debe tener al menos 9 números.",
        ],
        noVacio: [
          // @ts-ignore
          v => {
            if(!v || v.trim() === ''){
              return 'Campo requerido'
            }else if(v.trim() === '0'){
              return 'Campo requerido'
            }else{
              return true
            }
          }
        ],
      },
      dialog: false,
      btn: {
        clickable: false,
        loading: false,
        isOk: null,
        successText: "Guardado correctamente",
        errorText: "Error interno",
      },
      errorMessage: [],
      passwordError: null,
      blockedName: null,
      disabledName: null,
      consultarRut: 'SI',
      validPassword :{
        length: false,
        number: false,
        capital: false,
        symbol: false
      },
      chipFIN: false,
      chipINV: false,
      formValid: false,
      attempted: false,
    };
  },
  computed: {
    canSubmit() {
      const selectChip = this.$data.chipFIN == false && this.$data.chipINV == false ? false : true;
      const contratoOk = this.$data.user.type == 3 ? this.$data.contratoSolicitante : this.$data.contratoInversor;
      return this.$data.terms && contratoOk && this.$data.formValid && !this.$data.btn.loading && selectChip;
    }
  },
  async beforeMount() {
    if(this.$route.params.tipo){
     this.$data.user.type = this.$route.params.tipo

      if(this.$data.user.type == 2){
        this.$data.chipINV = true;
      }else if(this.$data.user.type == 3){
        this.$data.chipFIN = true;
      }
    }
    if(this.$route.query.qrcode !== undefined && this.$route.query.qrcode !== null){

      const { qrcode } = this.$route.query;
      const uniqueIP = `${this.$store.state.token_ip}_${this.$store.state.ip}`
      //@ts-ignore
      API.sincronizarIngresoRegistro(qrcode, uniqueIP);
    }

    if (this.$route.query.h != null) {
       API.getlanding(this.$route.query.h)
      .then((res: any) =>{
         let i = res[0];
        this.$data.user.name = i.name +' ' + i.lastname
        this.$data.user.lastname = i.lastname
        this.$data.user.email = i.email
        this.$data.user.phone = i.phone
        this.$data.user.type = i.tipo
      })
      .catch((err) =>{

      })
    }

    if(this.$route.query.utm_source != null){
      if(this.$route.query.utm_source  == 'Wrow' || this.$route.query.utm_source  == 'Redon_Wrow'){
        this.$data.user.utm_source = this.$route.query.utm_source;
        this.$data.user.via_id = 4;
      }
    }

    API.getPasswordRules().then((response) => {
      const res = response.data;
      const rules = JSON.parse(res.data);
      Object.values(rules).map((e) => {
        //@ts-ignore
        let rule = {'text': Object.values(e)[0].text, 'regex':Object.values(e)[0].rule}
        this.$data.rules.password = [...this.$data.rules.password, rule];
      });
    }).catch(() =>{
      this.$data.rules.password = [];
    })

    // @ts-ignore
    this.selectChipByDefault();
   
  },
  watch: {
    terms() {
      // @ts-ignore
      this.validate();
    },
    'user.type': {
      handler: function() {
        this.$data.contratoInversor = false
        this.$data.contratoSolicitante = false
        // @ts-ignore
        this.validateBox()
      },
      deep: true
    },
    'contratoInversor': {
      handler:function(){
        // @ts-ignore
        this.validate();
      },      
      deep: true
    },
    'contratoSolicitante':{
      handler:function(){
        // @ts-ignore
        this.validate();
      },      
      deep: true
    },  
  },
  methods: {
    validDni(){
      if(this.$data.user.dni){
        if(this.$data.user.dni.split('.').join('').slice(0, 2) > 35 && this.$data.user.dni.split('.').join('').length >= 10){
          EventBus.$emit("snack-error", 'Para registrarse debe utilizar Rut de persona');	
        }
      }
    },
    validatee() {
      // validate your form , if you don't have validate prop , default validate pass .
      return true;
    },
    callback(token) {
      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        this.$data.tokenn = token
        //@ts-ignore
        this.onSubmit(token)
      }else{
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
       // alert('please check you are not robot');
        this.$data.canPress = true;
        this.$data.errorMessage = "Error";
      }
    },
    validate() {
      if (this.$data.terms == true) {
        // @ts-ignore
        if (this.$refs.form.validate()) {
          if (this.$data.contratoInversor == true || this.$data.contratoSolicitante == true){        
            this.$data.btn.clickable = true;
            this.$data.passwordError = null;            
          }
        } else {
          this.$data.btn.clickable = false;
          this.$data.passwordError = null;
        }
      }
    },
    validateBox(){
      if (this.$data.terms == true && this.$data.contratoInversor == true ||
      this.$data.terms == true && this.$data.contratoSolicitante == true ) {               
        this.$data.btn.clickable = true;
        this.$data.passwordError = null;      
      } else {
        this.$data.btn.clickable = false;
        this.$data.passwordError = null;
      }
    },
    termError() {
      this.$data.showError = true;
      setTimeout(() => {
        this.$data.showError = false;
      }, 2500);
    },
    login() {
      EventBus.$emit(
        "open-login-dialog",
        this.$route.query.to != null ? `${this.$route.query.to}` : ""
      );
    },
    verificarRegex(regex:string, password:string):boolean{
        var pattern = new RegExp(regex);
        return pattern.test(password);
    },
    validatePassword(password) {
      const rules = this.$data.rules.password || [];
      if (!rules.length) return true;

      // @ts-ignore
      return rules.every((r: any) => this.verificarRegex(r.regex, password));
    },
    async onSubmit(token) {

      //@ts-ignore
      const ok = this.$refs.form.validate();
      if(!ok) return;

      this.$data.btn.loading = true;
      this.$data.errorMessage = [];

      this.$data.user.c_password = this.$data.user.password;

      try {
        
        const { nombre, apPat, apMat } = parseNombreCompleto(this.$data.user.name);
        if (!apPat) {
          this.$data.errors.push('Falta registrar su apellido');
          return;
        }
        const dni = DniTrim.string(this.$data.user.dni);

        const res : any = await API.register(
          token,
          nombre.trim(), 
          apPat, 
          this.$data.user.email, 
          this.$data.user.password,
          this.$data.user.c_password, 
          dni, 
          this.$data.user.via_id,
          this.$data.user.phone, 
          this.$data.user.type, 
          apMat
        );

        if(res.status != 200){
          this.$data.btn.isOk = false;
          this.$data.btn.loading = false;
          this.$data.errorMessage = [];
          if(res.message){
            EventBus.$emit('snack-error', res.message);
            this.$data.errorMessage.push(res.message);
          }

          return;
        }

        //@ts-ignore
        gtag('event', 'conversion', {'send_to': 'AW-11029767461/y65HCKSfhIMYEKXKs4sp'});
        //@ts-ignore
        gtag('event', 'Creó cuenta.', {
          'value': 'Creó cuenta.'
        });

        this.$data.btn.isOk = true
        this.$data.dialog = true
        setTimeout(() => {
          // se elimina cualquier negocio seleccionado de sesiones anteriores.
          this.$store.commit('setBusinessSelected',null);
          API.login(this.$data.user.dni, this.$data.user.password).then((data: any) => {
            this.$store.commit('setUser', data.usuario)
            this.$store.commit('setToken', data.access_token)
            this.$store.commit('setExpireTime', data.expires_at)
            this.$store.commit("setMenu", data.usuario.user_tipo_id);
            if(this.$data.user.type == 3){
              this.$router.push('/panel-facto/evaluacion-empresa');
            }else{
              this.$router.push({
                path: '/panel/inversionista/identificacion'
              })
            }
          }).catch((error) => {
              if(error && error.status === 401){
                this.$router.push({ path: '/block-account' });
              }
          });
        }, Configuration.Redirection.timeout)

      } catch (error) {
        this.$data.btn.isOk = false;
        this.$data.btn.loading = false;
        this.$data.errorMessage.push("Intente nuevamente");
        // @ts-ignore
        EventBus.$emit('snack-error', error.message);
      }
    },
    doRecaptcha() {
      // @ts-ignore
      this.$refs.recaptchaRegister.execute();
    },
    dataResponseConsultando(data){
      if(data){
        this.$data.blockedName = true;
      }else{
        this.$data.blockedName = false;
      }
    },
    dataResponse(data){
      // IF compara si el rut ingresado pertenece a una empresa o persona 12345678-9
      if(this.$data.user.dni.split('.').join('').slice(0, 2) > 35 && this.$data.user.dni.split('.').join('').length >= 10){
        EventBus.$emit("snack-error", 'Para registrarse debe utilizar rut de persona');	
      } else {
        //this.$data.valida.rutEmpresa = false;
        if(data.data.presenta_inicio_actividades == 'NO'){ // Evalua si tiene inicio de actividad para setar o no el valor de nombre
          this.$data.disabledName = false;
          this.$data.user.name = '';
        }else{ 
          this.$data.disabledName = true;
          this.$data.user.name = data.data.razon_social;
        }
      }
    },
    dataResponseVacio(){
      this.$data.user.name = '';
    },
    handleChipValue(action: string){
      if(action === 'inversion'){
        this.$data.chipINV = true;
        this.$data.chipFIN = false;
        this.$data.user.type = 2;
      } else if(action === 'financiamiento'){
        this.$data.chipFIN = true;
        this.$data.chipINV = false;
        this.$data.user.type = 3;
      }
    },
    onClickRegister(){

      //@ts-ignore
      if (!this.canSubmit || this.btn.loading) return;

      this.$data.attempted = true;
      // @ts-ignore
      const ok = this.$refs.form.validate();
      if (!ok) return;

      //@ts-ignore
      if (!this.canSubmit) { this.termError(); return; }

      //@ts-ignore
      this.doRecaptcha();
    },
    onFieldChange() {
      if (this.$data.errors && this.$data.errors.length) this.$data.errors = [];

      if (!this.$data.attempted) return;
      // @ts-ignore
      this.$refs.form && this.$refs.form.validate();
    },
    selectChipByDefault(){
      if(this.$data.user.type == null){
        this.$data.user.type = 3;
        this.$data.chipFIN = true;
      }else{
        if(this.$data.user.type == 2){
          this.$data.chipINV = true;
        }else if(this.$data.user.type == 3){
          this.$data.chipFIN = true;
        }
      }
    }
  },
  components: {
    DniField,
    ReusableButton,
    gRecaptcha,
    DniBusiness
  },
})
export default class Register extends Vue {}
